import { once } from 'lodash-es';
import { CultureCode } from '../culture/culture';

export const appBaseHrefFactory = once(
    (isEpiserver: boolean, cultureCode: CultureCode) => {
        if (isEpiserver) {
            return `/${cultureCode.toLocaleLowerCase()}/app/`;
        } else {
            return `/`;
        }
    }
);
